import Rx from 'rx';

export default function MagicLoginCtrl($scope, $magicWamp, $localstorage) {
  $scope.autoSubmitDuration = 3;
  $scope.showMagicMessage = false;

  $magicWamp.open();

  var tokenData = JSON.parse($localstorage.get('twofactordata'));

  $scope.$on("magic-wamp.onchallenge", function (event, data) {
    if (data.method === "send_token") {
      return data.promise.resolve(tokenData.two_factor_token);
    }
  });

  $magicWamp.subscribe('code', function (args) {
    $magicWamp.close();
    var code = args[0];
    $scope.code = '';

    Rx.Observable.from(code.split(''))
        .zip(Rx.Observable.interval(200).take(code.length))
        .map(function (x) {
          return x[0];
        })
        .subscribe(
            function (d) {
              $scope.$apply(function () {
                $scope.code = $scope.code + d;
              });
            },
            function () {
            },
            function () {
              $scope.$apply(function () {
                $scope.showMagicMessage = true;
              });

              Rx.Observable.interval(1000)
                  .take($scope.autoSubmitDuration)
                  .subscribe(
                      function (i) {
                        $scope.$apply(function () {
                          $scope.countDown = ($scope.autoSubmitDuration - i - 1).toString();
                        });
                      },
                      function (error) {

                      },
                      function () {
                        $scope.sendTwoFactorCode(code);
                      });
            });

  });

}